export const AGENTE_URL = process.env.REACT_APP_AGENTE_URL;

const STORAGE_KEY = "plazafy_borrador";

export const saveBorradorToken = (token) => {
  try { localStorage.setItem(STORAGE_KEY, token); } catch { /* noop */ }
};

export const getBorradorToken = () => {
  try { return localStorage.getItem(STORAGE_KEY); } catch { return null; }
};

export const clearBorradorToken = () => {
  try { localStorage.removeItem(STORAGE_KEY); } catch { /* noop */ }
};

export const borradorRedirectPath = () => {
  const t = getBorradorToken();
  return t ? `/add-spot?borrador=${encodeURIComponent(t)}` : null;
};

export const notifyBorradorPublicado = (token, spotId) => {
  if (!AGENTE_URL || !token) return;
  fetch(`${AGENTE_URL}/api/borradores/${encodeURIComponent(token)}/publicado`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ spot_id: spotId }),
  }).catch(() => {});
};
